export const initialState = {
  list: [], // CUSTOMER LIST
  selectedSystems: [],
  selectedMapSystems: [],
  selectedSensorSite: null, // for the sensor management view, only single sensor site can be selected
  isFetchingCustomers: false,
  editView: { editViewEnabled: false, selectedSiteName: "", selectedDeviceId: "" },
  createCustomerView: false,
  createDeviceView: false,
};
